import { InventoryAdjustmentCreatePage } from '@/features/inventory-adjustment/pages/InventoryAdjustmentCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

export const Route = createFileRoute('/admin/inventory-adjustment/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["inventory_adjustment.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: InventoryAdjustmentCreatePage,
  validateSearch: z.object({
    type: z.enum(["standard", "waste"]).optional().default("standard"),
  }),
})
